import React from 'react';
import { Button } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

const PageTitleActions = () => {
  return (
    <>
      <Button component={NavLink} to="/Orders" className="btn-primary">
        <span className="btn-wrapper--label">Recent Orders</span>
      </Button>
    </>
  );
};

export default PageTitleActions;
